<template>
    <modal ref="modalSubirArchivo" titulo="Subir archivo" no-aceptar :cargado-modal="loading" adicional="Cargar" @adicional="cargar">
        <p class="mx-0 f-14 px-4 text-general">Por favor seleccione la columna contra la cual desea comparar el archivo.</p>
        <div class="row mx-0 px-4 my-2">
            <el-radio v-model="tipo" :label="1">
                BarCode
            </el-radio>
            <el-radio v-model="tipo" :label="2">
                SKU
            </el-radio>
        </div>
        <div class="col-10 px-0 my-2">
            <p class="f-15 pl-3">Cedis Destino</p>
            <el-select v-model="id_cedis_destino" class="w-100 col-6" size="small" filterable placeholder="Seleccionar">
                <el-option
                v-for="item in cedis.filter(i=>i.id != 0)"
                :key="item.id"
                :label="item.nombre"
                :value="item.id"
                />
            </el-select>
        </div>    
        <div class="col-12 ">
            <p class="ml-2">Comentario</p>
            <el-input
            v-model="comentario"
            type="textarea"
            rows="4"
            placeholder="Digite la instrucciones de entrega"
            maxlength="250"
            show-word-limit
            />
        </div>    
        <div class="row mx-0 align-items-center py-3 px-4">
            <el-upload
            ref="upload"
            action="#"
            :on-change="changeFile"
            :on-remove="removeFile"
            :auto-upload="false"
            :multiple="false"
            :limit="1"
            accept=".xlsx"
            >
                <div class="bg-general2 text-white br-8 px-3 py-1 f-16 cr-pointer shadow">
                    Seleccionar archivo
                </div>
            </el-upload>
        </div>
        <p class="mx-0 f-14 px-4 text-general">Solo se aceptan archivos con extención ( .xlsx )</p>
    </modal>
</template>
<script>
import Productos from "~/services/productos/productos_stocks";
import {mapGetters} from 'vuex'
export default {
    data(){
        return {
            loading:false,
            file:null,
            remplazar:false,
            tipo:1,
            id_cedis_destino:null,
            comentario:''
        }
    },
    computed:{
         ...mapGetters({
            cedis:'cedis/cedis'
        }),
        id_cedis(){
            return Number(this.$route.params.id_cedis)
        },
    },
    methods: {
        toggle(){
            this.$refs.upload.clearFiles()
            this.$refs.modalSubirArchivo.toggle();
        },
        editar(origen){
            this.remplazar = true
            this.tipo = origen
            this.$refs.upload.clearFiles()
            this.$refs.modalSubirArchivo.toggle();
        },
        changeFile(file){
            this.file = file.raw
        },
        removeFile(){
            this.file = null
        },
        async cargar(){
            try {
                if(this.file === null) return
                let model = {
                    id_cedis:this.id_cedis,
                    id_cedis_destino:this.id_cedis_destino,
                    origen:this.tipo,
                    comentario:this.comentario,
                    file:this.file
                }
                model = this.crear_formData(model)
                this.loading =  true
                const {data} = await Productos.trasladarStockMasivo(model)
                this.$refs.modalSubirArchivo.toggle();
                this.notificacion('Mensaje', 'Archivo importado correctamente', 'success')
                this.$emit('update')
                
            } catch (e){
                this.error_catch(e)
            } finally {
                this.loading =  false
            }

        },
    }
}
</script>
